export default class Scroller{
	constructor(){
		this.scrollOnUpdateHandlerChain = [];
		this.initialize();
	}

	initialize(){
		//scroll smoother 初期化
		const onScrollUpdateHandler = (scrollTop)=>{
			this.scrollOnUpdateHandlerChain.forEach(handler=>{
				if(typeof handler == 'function') handler(scrollTop);
			});
		}

		if(window.currentContext == "pc"){	
			this.smoother = ScrollSmoother.create({
				smooth: 1.5,
				speed: 1,
				effects: true,
				normalizeScroll: true,
				onUpdate: self => {
					onScrollUpdateHandler(self.scrollTop());
				}
			});
			ScrollTrigger.normalizeScroll({allowNestedScroll: true});
			window.smoothscroller = this.smoother;
			window.addEventListener("siteReady", ()=>{ window.smoothscroller.refresh();	}, {once: true})
		}

		//ハッシュ付きURLで遷移してきた時
		if(location.hash){
			const isWedding = document.body.classList.contains("wedding");
			let hashTarget = document.querySelector(location.hash);
			if(hashTarget==null && document.body.classList.contains("contact")){
				if(document.body.querySelector("input[value='"+location.hash.substring(1)+"']")){
					hashTarget = document.querySelector("#mailform");
				}
			}
			const launch = ()=>{
				if(window.smoothscroller) window.smoothscroller.refresh();
				if(hashTarget){
					setTimeout(()=>{
						if(this.smoother){
							this.smoother.scrollTo(hashTarget, false, "top "+(isWedding ? window.rpx(window.currentContext=="pc" ? 100 : 111) : 0)+"px");
						}else{
							gsap.to(window, 0, {
								scrollTo: {
									y:hashTarget,
									autoKill:false,
									offsetY: (isWedding ? window.rpx(window.currentContext=="pc" ? 100 : 111) : 0)
								}
							});
						}
					}, 100);
				}
			}
			launch();
		}

		//内部スクロールリンク設定
		const isWedding = document.body.classList.contains("wedding");
		const anchorlinks = document.querySelectorAll("a[href^='#']");
		anchorlinks.forEach(link=>{
			link.addEventListener("click", (e)=>{
				const href = link.getAttribute("href");
				let target = (href.length == 1) ? 0 : href;
				if(this.smoother){
					this.smoother.scrollTo(target, true, "top "+(isWedding ? window.rpx(window.currentContext=="pc" ? 100 : 111) : 0)+"px");
				}else{
					gsap.to(window, 1, {
						scrollTo: {
							y:target,
							autoKill:false,
							offsetY: (isWedding ? window.rpx(window.currentContext=="pc" ? 100 : 111) : 0)
						},
						ease: "expo.out"
					});
				}
				e.stopPropagation();
				e.preventDefault();
				return false;
			});
		});

		const sectionheadings = document.querySelectorAll(".sectionheading");
		sectionheadings.forEach(sectionheading=>{
			ScrollTrigger.create({
				trigger: sectionheading,
				start: "top 80%",
				onEnter:     ()=>{ sectionheading.classList.add("appear"); },
				onLeaveBack: ()=>{ sectionheading.classList.remove("appear"); },
			});
		})
	}

	appendScrollHandler(handler){
		this.scrollOnUpdateHandlerChain.push(handler);
	}
	scrollTo(hash, immediate = false){
		const isWedding = document.body.classList.contains("wedding");
		let hashTarget = document.querySelector(hash);
		if(hashTarget==null && document.body.classList.contains("contact")){
			if(document.body.querySelector("input[value='"+location.hash.substring(1)+"']")){
				hashTarget = document.querySelector("#mailform");
			}
		}
		if(hashTarget){
			if(window.smoothscroller) window.smoothscroller.refresh();
			requestAnimationFrame(()=>{requestAnimationFrame(()=>{
				if(this.smoother){
					this.smoother.scrollTo(hashTarget, true, "top "+(isWedding ? window.rpx(window.currentContext=="pc" ? 100 : 111) : 0)+"px");
				}else{
					gsap.to(window, 0.25, {
						scrollTo: {
							y:hashTarget,
							autoKill:false,
							offsetY: (isWedding ? window.rpx(window.currentContext=="pc" ? 100 : 111) : 0)
						}
					});
				}
			})});
		}
	}
}